const THEME = {
  BACKGROUND_COLOR: 'white',

  BORDER_COLOR: '#E8EBEE',
  ALTERNATE_BORDER_COLOR: '#D2D8DE',

  KEY_COLOR: 'rgb(48, 52, 63)',
  TYPE_COLOR: '#8A93A3',

  /* Value */
  VALUE_COLOR: '#5D6470',
  VALUE_BACKGROUND_COLOR: '#F0F1F4',
  VALUE_BORDER_RADIUS: '3px',
  VALUE_FONT_WEIGHT: '600',
  VALUE_PADDING_TOP: '4px',
  VALUE_PADDING_BOTTOM: '4px',
  VALUE_PADDING_LEFT: '8px',
  VALUE_PADDING_RIGHT: '8px',

  /* Description */
  DESCRIPTION_COLOR: '#8A93A3',

  /* ArrayHeader */
  ARRAY_HEADER_BACKGROUND_COLOR: '#E8EBEE',
  ARRAY_HEADER_BORDER_COLOR: '#E8EBEE',

  /* ArrayItem */
  ARRAY_ITEMS_BORDER_COLOR: '#E8EBEE',

  /* SampleToggle */
  SAMPLE_TOGGLE_TITLE_COLOR: '#A3A7B2',

  /* InheritanceTree */
  INHERITANCE_TREE_NODE_COLOR: '#30343F',
  INHERITANCE_TREE_ROOT_NODE_COLOR: '#30343F',
  INHERITANCE_TREE_CURRENT_NODE_COLOR: '#8A93A3',

  ROW_PADDING_TOP: '14px',
  ROW_PADDING_BOTTOM: '14px',

  /* Select (One Of) */
  SELECT_LINE_COLOR: '#BDC4CB',
  SELECT_TEXT_COLOR: 'black',

};

export default THEME;



// WEBPACK FOOTER //
// ./src/Resources/theme.js